function getCookie(name: string): string | null {
    if (typeof document === "undefined") return null;
    const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const match = document.cookie.match(new RegExp("(?:^|; )" + escaped + "=([^;]*)"));
    return match ? decodeURIComponent(match[1]) : null;
}

export function getCookieCsrfHeaders(method?: string): Record<string, string> {
    const unsafe = ["post", "put", "patch", "delete"].includes((method ?? "get").toLowerCase());
    if (!unsafe) {
        return {};
    }

    const fingerprintCookie = getCookie("fp");
    return fingerprintCookie ? { "X-CSRF-Token": fingerprintCookie } : {};
}
